/**
 * @Create idler.zhu(zqc.sunny@aliyun.com)
 * @CreateDate  2017/12/28
 */
import './index.css';
import React, {Component} from 'react';
import Input from '../../lib/input'

class FormRow extends Component {
  static defaultProps = {
    info: null,
    rules: []
  };
  state = {
    info: this.props.info
  };
  handleChange = (e) => {
    const value = e.target.value;
    if (this.checkAndTips(value)) {
      return this.props.onChange(value);
    }
    return this.props.onChange(null);
  };
  handleBlur = (e) => {
    const value = e.target.value;
    this.checkAndTips(value);
  };
  checkAndTips (value) {
    const { rules } = this.props;
    for (let i = 0; i < rules.length; i++) {
      if (!rules[i].regExp.test(value)) {
        this.setState({
          info: rules[i].info
        });
        return false;
      }
    }
    this.setState({
      info: null
    });
    return true;
  }
  componentWillReceiveProps (nextProps) {
    if (nextProps.info !== null) {
      this.setState({
        info: nextProps.info
      });
    }
  }
  render () {
    const { title, children, placeholder, maxLength, className } = this.props;
    const { info } = this.state;
    return <div className="mcycle-express-content-row clearfix">
      <div className="mcycle-content-title">{title}</div>
      {children
        ? children
        : <Input type="text"
                 className={className}
                 onBlur={this.handleBlur}
                 onChange={this.handleChange}
                 error={info}
                 placeholder={placeholder}
                 maxLength={maxLength}/>
      }
      {info ? <div className="mcycle-express-content-tips">{info}</div> : null}
    </div>
  }
}

export default FormRow;



// WEBPACK FOOTER //
// ./src/components/step2/formRow/index.js